import { render, staticRenderFns } from "./LostFoundCreate.vue?vue&type=template&id=437b98ce"
import script from "./LostFoundCreate.vue?vue&type=script&lang=js"
export * from "./LostFoundCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports